import React from 'react';
import { ReactComponent as RedirectArrowIconSVG } from '../../assets/icons/mevo/ic_redirect_arrow.svg';
import IconPattern, { IconProps } from './_IconPattern';

const RedirectArrowIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={RedirectArrowIconSVG} variantPlaces={[]} {...props} />;
};
export default RedirectArrowIcon;
